<template>
	<div class="about">
		<div class="title-box">
			<img src="@/assets/images/title_about.png"/>
		</div>
		
		<div class="main">
			<div class="left">
				<img src="@/assets/images/about_pic.png"/>
			</div>
			<div class="right">
				<img src="@/assets/images/title_about_1.png"/>
				<p>鹿优选是一家创新引领的购物平台，专注于通过大数据技术为新青年定制智能化的商品推荐，精准满足个性化需求。</p>
			</div>
		</div>
		
		<div class="bg"></div>
		
		<div class="btm">
			<div class="in">
				<p>我们的专注<br/>让购物变得更加简单 。</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods: {},
	}
</script>

<style scoped lang="less">
	.about{
		padding-top: 130px;
		background: #FBFBFB;
	}
	.title-box{
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: 84px;
		}
	}
	.bg{
		height: 355px;
		background: #F9F3E9;
		border-radius: 0 60px 60px 0;
		position: absolute;
		left: 0;
		top: 327px;
		right: 47%;
	}
	.main{
		display: flex;
		align-items: center;
		padding-bottom: 60px;
		width: 1200px;
		margin: 0 auto;
		position: relative;
		z-index: 2;
		.left{
			img{
				width: 615px;
				height: auto;
				animation: floatAnimation 3s infinite;
			}
		}
		.right{
			padding-left: 158px;
			img{
				width: 254px;
				height: auto;
				margin-bottom: 30px;
			}
			p{
				color: #252525;
				font-size: 20px;
				font-weight: 300;
				width: 430px;
			}
		}
	}
	.btm{
		background:#FF4F6A url("../../assets/images/about_btm_bg.png") no-repeat right center;
		background-size: auto 100%;
		.in{
			width: 1060px;
			height: 286px;
			margin: 0 auto;
			color: #fff;
			display: flex;
			align-items: center;
			font-size: 50px;
			font-weight: bold;
		}
	}
	
	@keyframes floatAnimation {
	  0% {
	    transform: translateX(0);
	  }
	  50% {
	    transform: translateX(30px);
	  }
	  100% {
	    transform: translateX(0);
	  }
	}
</style>
